import React from 'react';
import { Col, FormGroup, Checkbox } from 'react-bootstrap';
import {salesforce_users} from '../../../lib/Helpers';

/**
 * @deprecated we deprecated SF that's why we have no assignee because it was SF depended feature
 * */
class AssigneeFilters extends React.Component {
  state = {assignees: []}
  static assignees = []

  componentDidMount(){
    this.loadAssignees();
  }

  loadAssignees(){
    salesforce_users().then(function(result){
      const salesforce_user_array = result.salesforce_users;
      const assignees = salesforce_user_array.map((salesforce_user)=>Object.keys(salesforce_user)[0])
      this.setState({assignees: assignees.concat(['None'])})
    }.bind(this));
  }

  updateAssignee(e){
    const assignee = e.target.name;
    const checked = e.target.checked;

    if(checked){
      this.props.addAssignee(assignee);
    } else {
      this.props.removeAssignee(assignee);
    }
  }

  render(){
    const self = this;
    return null
    return(
      <Col md={6}>
        <label className="control-label">Assignees</label>
        <FormGroup>
          {
            this.state.assignees.map(function(assignee){
              return(
                <Checkbox
                  key={assignee}
                  name={assignee}
                  checked={self.props.selectedAssginees.includes(assignee)}
                  inline
                  onChange={self.updateAssignee.bind(self)}
                >
                  {assignee}
                </Checkbox>
              )
            })
          }
        </FormGroup>
      </Col>
    )
  }
}

export default AssigneeFilters;